import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-customer-dealer-association',
  templateUrl: './customer-dealer-association.component.html',
  styleUrls: ['./customer-dealer-association.component.css']
})
export class CustomerDealerAssociationComponent {
  @Input() customerDealerAssociation: any;
  @Input() customerNo: any;
  @Input() customerName: any;
  
  constructor(private activeModal: NgbActiveModal) { }

  OnClose() {
    this.activeModal.close();
  }
}
